<template>
  <model-table
    title="Discounts"
    :collection="membershipType.membershipDiscounts"
    :submodel="true"
    :columns="[
      { field: 'name', align: 'left', sortable: true },
      { name: 'discount', align: 'left', field: row => row.discount.name, sortable: true },
      { name: 'limit', align: 'left', field: row => { return row.limitRedemptions ? $_.startCase(row.redemptionsLimit + ' every ' + row.renews + ' ' + row.renewalTerm) : 'Unlimited' } },
      { field: 'formattedConditions', align: 'left', label: 'Conditions', component: 'chips', limitValues: 3 },
      { field: 'enable', align: 'left', label: 'Enabled', component: 'checkmark-or-negative' },
      { field: 'actions' }
    ]"
    add-label="Discount"
  >
    <membership-discount-form
      ref="membershipDiscountForm"
      :submodel="true"
      :membership-type="membershipType"
    />
  </model-table>
</template>

<script>

import MembershipType from 'src/models/membership-type/MembershipType'
import ModelTable from 'src/modules/admin/components/ModelTable'
import MembershipDiscountForm from 'src/modules/admin/membership-type/MembershipDiscountForm'

export default {
  name: 'MembershipDiscountTable',
  components: {
    ModelTable,
    MembershipDiscountForm
  },
  props: {
    membershipType: {
      type: MembershipType,
      required: true
    }
  }
}
</script>
